import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Facility, FacilityUpdate } from "../../types/facility.definition";

interface FacilityState {
  facility: Facility | null;
  loading: boolean;
  updating: boolean;
  error: string | null;
  updateError: string | null;
}

const initialState: FacilityState = {
  facility: null,
  loading: false,
  updating: false,
  error: null,
  updateError: null,
};

const facilitySlice = createSlice({
  name: "facility",
  initialState,
  reducers: {
    fetchFacilityRequest: (
      state,
      _action: PayloadAction<{ facilityId: string | number }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchFacilitySuccess: (
      state,
      action: PayloadAction<{ facility: Facility }>
    ) => {
      state.facility = action.payload.facility;
      state.loading = false;
      state.error = null;
    },
    fetchFacilityFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateFacilityRequest: (
      state,
      _action: PayloadAction<{
        facilityId: number;
        data: Partial<FacilityUpdate>;
      }>
    ) => {
      state.updating = true;
      state.updateError = null;
    },
    updateFacilitySuccess: (
      state,
      action: PayloadAction<{ facility: Facility }>
    ) => {
      state.facility = action.payload.facility;
      state.updating = false;
      state.updateError = null;
    },
    updateFacilityFailure: (state, action: PayloadAction<string>) => {
      state.updating = false;
      state.updateError = action.payload;
    },
    setFacility: (state, action: PayloadAction<Facility>) => {
      state.facility = action.payload;
    },
  },
});

export const {
  fetchFacilityRequest,
  fetchFacilitySuccess,
  fetchFacilityFailure,
  updateFacilityRequest,
  updateFacilitySuccess,
  updateFacilityFailure,
  setFacility,
} = facilitySlice.actions;

export default facilitySlice.reducer;
